import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/krystal-purple.svg'


const _withScopeId = n => (_pushScopeId("data-v-5f30f88d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gemini-model" }
const _hoisted_2 = { class: "gemini-model__header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "write with crytal", -1))
const _hoisted_5 = { class: "gemini-model__body" }
const _hoisted_6 = { class: "gemini-model__prompt-input" }
const _hoisted_7 = { class: "gemini-model__text" }
const _hoisted_8 = { class: "gemini-model__text-inner" }
const _hoisted_9 = { class: "gemini-model__text-footer" }
const _hoisted_10 = { class: "gemini-model__footer" }

import { ref } from "vue";
import { PROJECT_STORE } from "@/store/modules/project";
import { useStore } from "vuex";
import CommonDialog from "@/core/components/CommonDialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GeminiModelForMobileView',
  props: {
  isTitleKrystalIconClick: {
    type: Boolean,
    default: false,
  },
},
  emits: ["appendJobDescription", "onClose"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const store = useStore();
const jobDiscriptionRecommendationInput = ref("");
const jobDiscriptionRecommendationOutput = ref("");
const isLoading = ref(false);
const disableBtn = ref(false);
const props = __props;
const generateRecommendationForJobDescription = async () => {
  if (jobDiscriptionRecommendationInput.value) {
    jobDiscriptionRecommendationOutput.value = "";
    isLoading.value = true;
    disableBtn.value = true;
    let response;
    if (!props.isTitleKrystalIconClick) {
      response = await store.dispatch(
        `${PROJECT_STORE}/getRecommendationForJobDescription`,
        {
          prompt: jobDiscriptionRecommendationInput.value,
        }
      );
    } else {
      response = await store.dispatch(
        `${PROJECT_STORE}/getRecommendationForJobTitle`,
        {
          prompt: jobDiscriptionRecommendationInput.value,
        }
      );
    }

    const tempText = response.text.split(" ");
    isLoading.value = false;

    const printInterval = setInterval(() => {
      jobDiscriptionRecommendationOutput.value += ` ${tempText.shift()}`;
      if (!tempText.length) {
        clearInterval(printInterval);
        disableBtn.value = false;
      }
    }, 250);
  }
};

const cleanBody = () => {
  jobDiscriptionRecommendationInput.value = "";
  jobDiscriptionRecommendationOutput.value = "";
};

const copyContent = async () => {
  await navigator.clipboard.writeText(jobDiscriptionRecommendationOutput.value);
};
const insertContent = () => {
  if (jobDiscriptionRecommendationOutput.value) {
    emit("appendJobDescription", jobDiscriptionRecommendationOutput.value);
    cleanBody();
  } else {
    onClose();
  }
};
const onClose = () => {
  emit("onClose");
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(CommonDialog, {
    isShowHeader: false,
    isShowBackButton: false,
    width: "100%",
    "max-width": "500px",
    height: "auto",
    className: ['gemini_model_dialog']
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createVNode(_component_v_btn, {
            icon: "mdi-close",
            onClick: onClose,
            density: "compact",
            variant: "text"
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_text_field, {
              autofocus: true,
              modelValue: jobDiscriptionRecommendationInput.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((jobDiscriptionRecommendationInput).value = $event)),
              onKeyup: _withKeys(generateRecommendationForJobDescription, ["enter"]),
              placeholder: "Enter prompt",
              variant: "outlined",
              class: "input_field",
              "bg-color": "#fff"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_v_btn, {
              onClick: generateRecommendationForJobDescription,
              disabled: disableBtn.value,
              variant: "text",
              density: "compact",
              icon: "mdi-send"
            }, null, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_v_textarea, {
                "bg-color": "white",
                "base-color": "white",
                density: "compact",
                variant: "solo",
                class: "input_field input_textarea",
                flat: "",
                "no-resize": "",
                rows: "1",
                loading: isLoading.value,
                modelValue: jobDiscriptionRecommendationOutput.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((jobDiscriptionRecommendationOutput).value = $event))
              }, null, 8, ["loading", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", { onClick: copyContent }, [
                _createVNode(_component_v_icon, {
                  icon: "mdi-content-copy",
                  color: "#80829F"
                })
              ]),
              _createElementVNode("button", { onClick: cleanBody }, [
                _createVNode(_component_v_icon, {
                  icon: "mdi-trash-can-outline",
                  color: "#80829F"
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_v_btn, {
            disabled: disableBtn.value,
            onClick: insertContent,
            class: "button button-purple"
          }, {
            default: _withCtx(() => [
              _createTextVNode("insert")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_v_btn, {
            disabled: disableBtn.value,
            class: "button button-white",
            onClick: generateRecommendationForJobDescription
          }, {
            default: _withCtx(() => [
              _createTextVNode("regenrate")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})